export default "__VITE_ASSET__B1YSrGxh__"